import React, { useState } from 'react'
import { User, Bell, Shield, Palette } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'

const Settings = () => {
  const { user } = useAuth()
  const [tab, setTab] = useState('profile')

  const tabs = [
    { id: 'profile', label: 'Profile', icon: User },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'appearance', label: 'Appearance', icon: Palette },
    { id: 'security', label: 'Security', icon: Shield },
  ]

  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-500 mt-1">Manage your account preferences</p>
      </div>

      <div className="flex space-x-2 bg-white rounded-2xl p-1.5 shadow-sm w-fit">
        {tabs.map(t => {
          const Icon = t.icon
          return (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`flex items-center px-4 py-2 rounded-xl text-sm font-medium transition-all ${
                tab === t.id ? 'bg-[#1E4D40] text-white shadow-md' : 'text-gray-600 hover:bg-gray-100'
              }`}>
              <Icon className="h-4 w-4 mr-1.5" /> {t.label}
            </button>
          )
        })}
      </div>

      <div className="bg-white rounded-3xl p-8 shadow-sm">
        {tab === 'profile' && (
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-900">Profile Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                <input defaultValue={user?.firstName || ''} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E4D40]/20 focus:border-[#1E4D40]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                <input defaultValue={user?.lastName || ''} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E4D40]/20 focus:border-[#1E4D40]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                <input defaultValue={user?.email || ''} className="w-full px-4 py-3 border border-gray-200 rounded-xl bg-gray-50" disabled />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Role</label>
                <input defaultValue={user?.role || ''} className="w-full px-4 py-3 border border-gray-200 rounded-xl bg-gray-50" disabled />
              </div>
            </div>
            <button className="px-6 py-3 bg-[#1E4D40] text-white rounded-xl font-medium hover:bg-[#163a30]">Save Changes</button>
          </div>
        )}
        {tab === 'notifications' && (
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-900">Notification Preferences</h3>
            {['Email notifications', 'Counterfeit alerts', 'Weekly reports', 'System updates'].map((label, i) => (
              <div key={i} className="flex items-center justify-between py-3 border-b border-gray-100">
                <span className="text-sm text-gray-700">{label}</span>
                <button className="relative w-11 h-6 bg-[#1E4D40] rounded-full transition-colors">
                  <span className="absolute right-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform" />
                </button>
              </div>
            ))}
          </div>
        )}
        {tab === 'appearance' && (
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-900">Appearance</h3>
            <p className="text-sm text-gray-500">Theme and display preferences</p>
            <div className="grid grid-cols-3 gap-4">
              <button className="p-4 border-2 border-[#1E4D40] rounded-xl text-center"><div className="w-8 h-8 bg-white border border-gray-200 rounded-lg mx-auto mb-2" /><span className="text-sm font-medium">Light</span></button>
              <button className="p-4 border border-gray-200 rounded-xl text-center"><div className="w-8 h-8 bg-gray-900 rounded-lg mx-auto mb-2" /><span className="text-sm font-medium">Dark</span></button>
              <button className="p-4 border border-gray-200 rounded-xl text-center"><div className="w-8 h-8 bg-gradient-to-br from-white to-gray-900 rounded-lg mx-auto mb-2" /><span className="text-sm font-medium">System</span></button>
            </div>
          </div>
        )}
        {tab === 'security' && (
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-900">Security Settings</h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Current Password</label>
              <input type="password" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E4D40]/20 focus:border-[#1E4D40]" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">New Password</label>
              <input type="password" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E4D40]/20 focus:border-[#1E4D40]" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Confirm New Password</label>
              <input type="password" className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E4D40]/20 focus:border-[#1E4D40]" />
            </div>
            <button className="px-6 py-3 bg-[#1E4D40] text-white rounded-xl font-medium hover:bg-[#163a30]">Update Password</button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Settings
